// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"style_rootContainer__38Bdw","headerContainer":"style_headerContainer__3R0uY","title":"style_title__2p9oR","subtitle":"style_subtitle__1TsZv"};